import cfg from './configuration/PropertiesConfiguration'

export class CreateProfileService {
  constructor (axios) {
    this.axios = axios
  }

  validateUsername (config) {
    return this.axios.get(cfg.validateUsernameUrl, config)
  }

  registerMember (config) {
    return this.axios.post(cfg.registerMemberUrl, config)
  }

  getMyProfileUrl () {
    return cfg.myProfileUrl
  }
}



// WEBPACK FOOTER //
// ./src/services/CreateProfileService.js